import { useEffect } from "react";
import { Link } from "react-router-dom";
import { track } from "../lib/tracking";
import { getUtms } from "../lib/utm";

export default function TerminBestaetigt() {
  useEffect(() => {
    track("PageView");
    if (!sessionStorage.getItem("2bs_termin_gebucht")) {
      sessionStorage.setItem("2bs_termin_gebucht", "1");
      const segment = getUtms().utm_content || "";
      track("Termin_gebucht", { customData: { segment } });
    }
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-5 py-24">
      <div className="max-w-2xl text-center">
        <h1 className="text-3xl font-semibold text-textdunkel sm:text-4xl" data-testid="danke-ueberschrift">
          Ihr Termin steht.
        </h1>
        <p className="mt-6 text-base leading-relaxed text-textgrau" data-testid="danke-text">
          Sie erhalten gleich eine Bestätigung per E-Mail. Damit wir die Zeit gut nutzen: Notieren Sie sich vorab, an
          welche Funktionen und Branchen Sie verkaufen. Den Rest machen wir gemeinsam im Sales Navigator.
        </p>
        <p className="mt-6 text-base font-medium text-textdunkel">Bis bald, Patrick Häfner</p>
        <Link
          to="/"
          data-testid="danke-zurueck"
          className="mt-9 inline-block rounded-full border border-navy px-8 py-3 text-sm font-semibold text-navy transition-colors duration-200 hover:bg-hellblau"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </main>
  );
}
